import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-24 px-4 bg-brand-gray relative border-y border-brand-border" data-id="element-106">
      <div className="max-w-3xl mx-auto text-center" data-id="element-107">
        <FadeIn data-id="element-108">
          <div className="flex justify-center mb-8" data-id="element-109">
            <div className="p-4 bg-brand-dark rounded-full border border-brand-border text-brand-orange" data-id="element-110">
              <Clock size={32} data-id="element-111" />
            </div>
          </div>

          <p className="text-2xl md:text-3xl font-display text-white leading-relaxed italic mb-8" data-id="element-112">
            "Son las 2 de la mañana. Una alerta de evacuación ruge en tu
            teléfono. Tienes exactamente{' '}
            <span className="text-brand-orange font-bold not-italic" data-id="element-113">
              15 minutos
            </span>{' '}
            para salir de tu casa antes de que sea demasiado tarde."
          </p>

          <div className="w-24 h-1 bg-brand-orange mx-auto mb-8" data-id="element-114" />

          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-115">
            ¿Sabes exactamente dónde están los pasaportes de tus hijos? ¿Tienes
            medicina para 3 días? ¿O vas a perder los minutos más vitales de tu
            vida dando vueltas en círculo en tu sala mientras el pánico te
            paraliza?
          </p>
        </FadeIn>
      </div>
    </section>;
}